import { useEffect, useState } from "react";

export function useMaxStep(currentStep: number | undefined) {
  const [maxStepReached, setMaxStepReached] = useState<number>(-1);

  useEffect(() => {
    if (currentStep && currentStep > maxStepReached)
      setMaxStepReached(currentStep);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return { maxStepReached };
}
